import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import React from 'react';
import { FileChartColumnIncreasing } from 'lucide-react';
import { useIntl } from 'react-intl';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const PowerBIReportsTabsHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const { account } = useAccountState();

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: account.company?.features.hasReports,
          label: intl.formatMessage({ id: 'powerBi.navigation.listReports' }),
          to: '/powerbi/reports',
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<FileChartColumnIncreasing size={25} color={'white'} />}
    />
  );
};

export default React.memo(PowerBIReportsTabsHeader);
